import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../utils/config';
import Button from '../../atoms/Button';
import SubHeadline from '../../atoms/SubHeadline';
import CheckboxField from '../../formik/CheckboxField';

type ProgramRegistrationProps = {
  onRegister: () => Promise<void>;
  isLoading?: boolean;
  isDisabled?: boolean;
};

const ProgramRegistration = ({ onRegister, isDisabled, isLoading }: ProgramRegistrationProps) => (
  <>
    <SubHeadline>
      <FormattedMessage id="payment.loyaltyProgram.register.headline" />
    </SubHeadline>
    <p className="loyalty-program__registration-info">
      <FormattedMessage id="payment.loyaltyProgram.register.description" />
    </p>
    <div className="loyalty-program__registration-benefits">
      {['benefit1', 'benefit2', 'benefit3'].map(key => (
        <div className="loyalty-program__registration-benefit" key={key}>
          <img src={getAssetUrl(`benefits/${key}.svg`)} />
          <span>
            <FormattedMessage id={`payment.loyaltyProgram.register.${key}`} />
          </span>
        </div>
      ))}
    </div>
    <Field
      component={CheckboxField}
      name="isTermsAndConditionsAccepted"
      className="loyalty-program__registration-checkbox"
      label={<FormattedMessage id="payment.loyaltyProgram.register.termsAndConditions" />}
      data-test-id="loyalty-program-registration"
    />
    <Button
      className="loyalty-program__registration-button"
      onClick={onRegister}
      isLoading={isLoading}
      disabled={isDisabled}
    >
      <FormattedMessage id="payment.loyaltyProgram.register.button" />
    </Button>
  </>
);

export default ProgramRegistration;
